import LinearProgressDisplay from '@brands/Components/ProgressDisplay/ProgressDisplay';
import { useWindowSize } from '@brands/hooks';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { useSnackbar } from '@brands/hooks/useStackbar';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import GenericSnackbar from '@brands/Utils/GenericSnackbar';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Container from '../../../../../Components/Container/Container';
import closeIcon from '../Icons/selectPatientClose.svg';
import logo from '../Icons/selectPatientLogo.svg';
import styles from './styles.module.scss';

const ClinicalDataIntro = (): JSX.Element => {
  const screenSize = useWindowSize();
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);

  const { snackbar, closeSnackbar } = useSnackbar();
  const { userInfo } = useAppSelector(selectAuth);
  const { currentOrganization } = useAppSelector(selectOrganization);

  const onContinue = (): void => {
    roleNavigate('/clinical-data/step-one', {
      state: {
        caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string,
        patientState: currentPatient?.address?.state,
        userOrganization: currentOrganization.id,
        patientId:
          userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin
            ? Number(selectedPatient?.value)
            : userInfo?.id,
      },
    });
  };

  const backToDashboard = (): void => {
    roleNavigate('/dashboard');
  };

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{
        zIndex: '2',
        paddingTop: screenSize.width > 768 ? '40px' : '16px',
        paddingBottom: screenSize.width <= 768 ? '16px' : '40px',
      }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={`fs-unmask ${styles.clinicalDataIntroContainer}`}>
        <div className={styles.clinicalDataIntroTopDiv}>
          <div className={styles.clinicalDataIntroTopDivFirst}>
            <img src={logo} className={styles.clinicalDataIntroTopDivFirstLogo} alt="Logo" />
            <div onClick={backToDashboard}>
              <img src={closeIcon} className={styles.clinicalDataIntroTopDivFirstClose} alt="Close" />
            </div>
          </div>
          <LinearProgressDisplay progress={10} />
        </div>
        <form className={`${styles.formContainer}`}>
          <div className={styles.clinicalDataIntroWrapper}>
            <div className={styles.clinicalDataIntroTitle}>Let’s get to know you better</div>
            <div className={styles.clinicalDataIntroBody}>
              <div className={styles.clinicalDataIntroBodyText}>
                We believe your oral health is a window to your overall well-being. To provide you with the best care,
                we need to learn a little more about your dental and medical history.
              </div>
              <div className={styles.clinicalDataIntroBodyText}>
                On the next few screens, we’ll ask you some quick questions about your health, lifestyle, and dental
                habits. This helps us personalize your care plan and ensure your smile stays bright and healthy.{' '}
              </div>
            </div>
            <div className={styles.clinicalDataIntroFooter}>
              <Button variant="text" className={styles.clinicalDataIntroFooterBack} onClick={() => navigate(-1)}>
                <ArrowBackIosNewIcon />
                Back
              </Button>
              <Button
                variant="contained"
                className={styles.clinicalDataIntroFooterNext}
                type="button"
                onClick={onContinue}
              >
                Next
              </Button>
            </div>
          </div>
        </form>
      </div>
      <GenericSnackbar open={snackbar.isOpen} message={snackbar.message} type={snackbar.type} onClose={closeSnackbar} />
    </Container>
  );
};
export default ClinicalDataIntro;
